import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Body = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("tbody", {
    ref: ref,
    children: children
  });
});
Body.displayName = 'Body';
Body.propTypes = {
  children: PropTypes.node
};
export default Body;